import { useState, useEffect } from 'react'

export default function TopBar({ stats, user }) {
  const [countdown, setCountdown] = useState('')

  useEffect(() => {
    if (!stats.nextBriefing) return

    const updateCountdown = () => {
      const now = Date.now()
      const diff = stats.nextBriefing - now

      if (diff <= 0) {
        setCountdown('NOW')
        return
      }

      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      if (hours > 0) {
        setCountdown(`${hours}h ${minutes}m`)
      } else {
        setCountdown(`${minutes}m`)
      }
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 60000)
    return () => clearInterval(interval)
  }, [stats.nextBriefing])

  const getTierBadge = () => {
    const tier = user?.tier || 'free'
    return (
      <span className={`tier-badge ${tier}`}>
        {tier.toUpperCase()}
      </span>
    )
  }

  return (
    <div className="top-bar">
      {/* Left Section - Signals Collected */}
      <div className="top-bar-section">
        <div className="top-bar-stat">
          <span className={`pulse-dot ${stats.signalsCollected > 0 ? '' : 'inactive'}`} />
          <span className="top-bar-stat-value">{stats.signalsCollected}</span>
          <span className="top-bar-stat-label">signals collected</span>
        </div>
      </div>

      {/* Center Section - Next Briefing */}
      <div className="top-bar-section">
        <div className="top-bar-countdown">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: 'var(--accent-cyan)' }}>
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span className="top-bar-countdown-label">Next briefing:</span>
          <span className="top-bar-countdown-time">{countdown}</span>
        </div>
      </div>

      {/* Right Section - Sources & Tier */}
      <div className="top-bar-section">
        <div className="sources-status">
          <div className="sources-dots">
            {Array.from({ length: 5 }).map((_, i) => (
              <span
                key={i}
                className="source-dot"
              />
            ))}
          </div>
          <span className="top-bar-stat-label">
            <span style={{ color: 'var(--text-bright)', fontFamily: 'var(--font-mono)' }}>
              {stats.sourcesTotal}
            </span>
            /{stats.sourcesTotal} sources
          </span>
        </div>

        {getTierBadge()}

        <button
          className="panel-action-btn"
          title="Settings"
          onClick={() => window.location.href = '/settings'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        </button>
      </div>
    </div>
  )
}
